import e, { createContext as t, createElement as n, forwardRef as r, startTransition as i, useCallback as a, useEffect as o, useImperativeHandle as s, useLayoutEffect as c, useMemo as l, useRef as u, useState as d } from "react";
import { useFactory as f, useInstance as p, useResources as m, useRouter as h, useSearchParams as g, useSignal as _, useStrictContext as v, useStrictInstance as y } from "@funtech-int/rival-react";
import { createFlags as b, createRef as x, createResourceQuery as ee, createSignal as S } from "@funtech-int/rival";
import { Fragment as C, jsx as w, jsxs as T } from "react/jsx-runtime";
import { stringifyUrl as E } from "query-string";
import { useIntl as te } from "react-intl";
import { createPortal as ne } from "react-dom";
import { GeoWidgetTriggerWrapper as re } from "@funtech-int/i18n-geo-widget/lazy";
import { clientRequestIdParser as ie, createRequestIdFactory as ae, getRequestId as oe, serverRequestIdParser as se } from "@kinopoisk-int/request-ids";
import { Offers as ce, PWTools as le, WidgetRouterWeb as ue } from "@plus-int/acq-toolkit";
import { useStorage as de } from "@funtech-int/web-toolkit";
import { Dcb as fe } from "@plus-int/acq-toolkit/dcb";
//#region \0rolldown/runtime.js
var pe = Object.defineProperty, me = (e, t) => {
	let n = {};
	for (var r in e) pe(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || pe(n, Symbol.toStringTag, { value: "Module" }), n;
};
//#endregion
//#region src/lib/analytics.ts
function he(e) {
	if (!e) throw Error("Evgen is not initialized");
}
function ge(e) {
	let t = /* @__PURE__ */ new Set();
	function n(t, n, r) {
		return he(e), r?.namespace ? t(e, r.namespace, n) : t(e, n);
	}
	return {
		send: n,
		sendOnce(e, r, i) {
			let a = i?.key ?? JSON.stringify(r);
			t?.has(a) || (t?.add(a), n(e, r, i));
		}
	};
}
//#endregion
//#region ../../../../../../../../../../../../home/sandbox/.nots/pnpm_store/v10/links/@kinopoisk-int/evgen-web-events/1.362.0/2dbe9843561c7ebff2c1aa10126c144bb664b72c33abf64664d34327c55354ae/node_modules/@kinopoisk-int/evgen-web-events/web/evgen_analytics.ts
var _e = /* @__PURE__ */ function(e) {
	return e.Android = "android", e.Ios = "ios", e.AndroidTv = "android_tv", e.HarmonyTv = "harmony_tv", e.ZeasnTv = "zeasn_tv", e.YandexTv = "yandex_tv", e.Tvos = "tvos", e.Tizen = "tizen", e.Orsay = "orsay", e.Webos = "webos", e.Playstation4 = "playstation4", e.Playstation5 = "playstation5", e.Xbox = "xbox", e.Web = "web", e.AospTv = "aosp_tv", e.Vidaa = "vidaa", e.Tvip = "tvip", e.Mina = "mina", e.Visionos = "visionos", e;
}({}), ve = /* @__PURE__ */ function(e) {
	return e.Yes = "yes", e.No = "no", e;
}({}), ye = /* @__PURE__ */ function(e) {
	return e.DefaultRegion = "default_region", e.Ip = "ip", e.Geo = "geo", e.Manual = "manual", e;
}({}), be = /* @__PURE__ */ function(e) {
	return e.Ltr = "ltr", e.Rtl = "rtl", e.NotSupported = "not_supported", e;
}({});
function xe(e, t, n) {
	return { trackEvent: (r, i) => {
		let a = {
			...i,
			...t.getGlobalParams(),
			...n.getPlatformParams()
		};
		e.trackEvent(r, a);
	} };
}
//#endregion
//#region src/lib/tracking.ts
var Se = "service-id", Ce = class {
	logger;
	apiUrl;
	serviceId;
	constructor({ trackingBaseUrl: e, serviceId: t, logger: n }) {
		this.apiUrl = `${e}/watch-batch`, this.serviceId = t, this.logger = n;
	}
	trackEvent(e, t) {
		let n = JSON.stringify([{
			...t,
			eventName: e
		}]);
		return navigator.sendBeacon && window.Blob && navigator.sendBeacon(this.apiUrl, new Blob([n], { type: "application/json" })) ? Promise.resolve() : fetch(this.apiUrl, {
			body: n,
			method: "POST",
			...this.serviceId ? { headers: { [Se]: String(this.serviceId) } } : {}
		}).catch((e) => {
			this.logger?.error({ error: e }, "Failed to track EvGen analytics data"), e instanceof Error && this.logger?.error({ error: e }, e.message);
		});
	}
}, we = class {
	providers;
	constructor({ providers: e }) {
		this.providers = e;
	}
	trackEvent(e, t) {
		this.providers.forEach((n) => n.trackEvent(e, t));
	}
}, Te = class {
	provider;
	constructor(e) {
		this.provider = e;
	}
	trackEvent(e, t) {
		this.provider.trackEvent(e, t);
	}
};
function Ee(e) {
	return [
		`%c[Evgen]%c %c[trackEvent]%c %c[${e}]`,
		"color: #fff; font-weight: bold; background: #194B77",
		null,
		"color: #fff; background: #806d3e",
		null,
		"color: #fff; background: #4f4473"
	];
}
var De = class extends Te {
	logger = console;
	hasDebugCookie = document.cookie.includes("_kp_debug=");
	constructor(e, t = Ee) {
		super(e), this.getEventMessageHeader = t;
	}
	trackEvent(e, t) {
		this.hasDebugCookie && this.logger.debug(...this.getEventMessageHeader(e), t), super.trackEvent(e, t);
	}
}, Oe = x("evgen"), ke = "unauthorized", Ae = "no–subscriptions", je = [
	"utm_source",
	"utm_medium",
	"utm_campaign",
	"utm_term",
	"utm_content"
];
function D(e) {
	return e ?? "-";
}
function Me(e, t) {
	return { getPlatformParams() {
		return {
			appVersion: e,
			yandexuid: D(t),
			referer: D(document.referrer),
			url: window.location.href
		};
	} };
}
function Ne({ featureFlags: e, authManager: t, trackedQueryParamsStore: n, locale: r, runtimeConfig: i, serviceName: a, sessionIds: o }) {
	return { getGlobalParams() {
		let s = n.getParams(je), c = t.userProfile?.billingFeatureNames, { isAuthorized: l } = t;
		return c?.length || (c = l ? [Ae] : [ke]), {
			experimentsFilter: {},
			deviceId: "-",
			platformName: _e.Web,
			osVersion: "-",
			cityName: "-",
			regionSource: ye.Ip,
			subscriptionType: "-",
			globalSessionId: D(o?.globalSessionId),
			localSessionId: D(o?.localSessionId.get()),
			featureToggles: {},
			experiments: e.grouped,
			regionId: D(String(i.regionId)),
			kpuid: "-",
			auth: l ? ve.Yes : ve.No,
			subprofileId: "-",
			childMode: !1,
			puid: t?.userProfile?.puid ? String(t?.userProfile.puid) : "-",
			billingFeatureNames: c,
			utmCampaign: D(s.utm_campaign),
			utmMedium: D(s.utm_medium),
			utmSource: D(s.utm_source),
			serviceName: a,
			lang: r.lang,
			textDirection: r.dir === "ltr" ? be.Ltr : be.Rtl,
			eventTimestamp: Date.now().toString()
		};
	} };
}
function Pe({ featureFlags: e, logger: t, authManager: n, trackedQueryParamsStore: r, locale: i, runtimeConfig: a, serviceName: o, sessionIds: s, appVersion: c, yandexuid: l, trackingsHost: u, metrikaProvider: d }) {
	let f = Me(c, l), p = Ne({
		featureFlags: e,
		authManager: n,
		trackedQueryParamsStore: r,
		locale: i,
		runtimeConfig: a,
		serviceName: o,
		sessionIds: s
	});
	return {
		...xe(new De(new we({ providers: [new Ce({
			trackingBaseUrl: u,
			logger: t
		}), d] })), p, f),
		ref: () => Oe
	};
}
//#endregion
//#region src/hooks/useEvgen.ts
function Fe() {
	return p(Oe);
}
//#endregion
//#region src/components/AnalyticsSenderProvider/AnalyticsSenderContext.ts
var Ie = t(null), Le = ({ children: e }) => {
	let t = Fe(), n = f(() => ge(t));
	return /* @__PURE__ */ w(Ie.Provider, {
		value: n,
		children: e
	});
};
//#endregion
//#region src/hooks/useAnalytics.ts
function Re(e) {
	let t = v(Ie);
	return f(() => e(t));
}
//#endregion
//#region src/lib/fromBlock.ts
var ze = "deviceUuid";
function Be(e) {
	return e.local.get(ze) ?? void 0;
}
function Ve(e) {
	return `${Be(e)}_${Date.now()}`;
}
var He = x("fromBlock"), Ue = (e) => {
	let t = Ve(e), n = 0, r = S(`${t}_${n}`);
	return {
		get sessionIds() {
			return {
				globalSessionId: t,
				localSessionId: r.seal()
			};
		},
		updateSession() {
			n += 1, r.set(`${t}_${n}`);
		},
		ref() {
			return He;
		}
	};
};
//#endregion
//#region src/hooks/useFromBlock.ts
function We() {
	return y(He);
}
function Ge(t) {
	let n = We();
	e.useEffect(() => {
		t && n && n.updateSession();
	}, [t, n]);
}
//#endregion
//#region src/components/SeoDefaultContext/SeoDefaultContext.ts
var Ke = t(null), O = () => v(Ke), qe = ({ url: e, lang: t, host: n, queryParams: r = {} }) => E({
	url: `${n}/${t}${e}`,
	query: r
}), Je = ({ url: e, locales: t, host: n, queryParams: r = {} }) => t.map((t) => ({
	href: E({
		url: `${n}/${t}${e}`,
		query: r
	}),
	hreflang: t
})), k = (e) => {
	let { currentLang: t } = O();
	return h().serialize(e)?.replace(RegExp(`^/${t}`), "");
}, Ye = ({ seoTitle: e, seoDescription: t, location: n, queryParams: r }) => {
	let i = O(), { Head: a, FaviconLinks: o } = i, s = k(n), c = qe({
		url: s,
		lang: i.currentLang,
		host: i.hostOrigin,
		queryParams: r
	}), l = Je({
		url: s,
		locales: i.locales,
		host: i.hostOrigin,
		queryParams: r
	});
	return /* @__PURE__ */ T(C, { children: [/* @__PURE__ */ T(a, { children: [
		/* @__PURE__ */ w("title", { children: e }, "title"),
		/* @__PURE__ */ w("meta", {
			name: "description",
			content: t
		}),
		/* @__PURE__ */ w("link", {
			rel: "canonical",
			href: c
		}, "canonical"),
		l.map(({ href: e, hreflang: t }) => /* @__PURE__ */ w("link", {
			rel: "alternate",
			href: e,
			hrefLang: t
		}, `${t}_alternate`))
	] }), /* @__PURE__ */ w(o, {})] });
}, Xe = ({ location: e, ogTitle: t, ogDescription: n, ogImage: r, ogImageWidth: i, ogImageHeight: a, ogImageAlt: o, ogType: s, queryParams: c }) => {
	let l = O(), u = k(e), { Head: d } = l, f = r || l.seoImage.url, p = i || l.seoImage.width, m = a || l.seoImage.height, h = qe({
		url: u,
		lang: l.currentLang,
		host: l.hostOrigin,
		queryParams: c
	});
	return /* @__PURE__ */ T(d, { children: [
		/* @__PURE__ */ w("meta", {
			property: "og:site_name",
			content: l.seoSiteName
		}, "og:site_name"),
		/* @__PURE__ */ w("meta", {
			property: "og:type",
			content: s
		}, "og:type"),
		/* @__PURE__ */ w("meta", {
			property: "og:title",
			content: t
		}, "og:title"),
		/* @__PURE__ */ w("meta", {
			property: "og:description",
			content: n
		}, "og:description"),
		/* @__PURE__ */ w("meta", {
			property: "og:url",
			content: h
		}, "og:url"),
		/* @__PURE__ */ w("meta", {
			property: "og:image",
			content: f
		}, "og:image"),
		/* @__PURE__ */ w("meta", {
			property: "og:image:width",
			content: String(p)
		}, "og:image:width"),
		/* @__PURE__ */ w("meta", {
			property: "og:image:height",
			content: String(m)
		}, "og:image:height"),
		!!o && /* @__PURE__ */ w("meta", {
			property: "og:image:alt",
			content: o
		}, "og:image:alt")
	] });
}, Ze = (e) => /* @__PURE__ */ w(Xe, {
	...e,
	ogType: "website"
}), Qe = ({ ogVideoDuration: e, ogVideoTags: t, ...n }) => {
	let { Head: r } = O();
	return /* @__PURE__ */ T(C, { children: [/* @__PURE__ */ w(Xe, {
		...n,
		ogType: "video.movie"
	}), /* @__PURE__ */ T(r, { children: [!!e && /* @__PURE__ */ w("meta", {
		property: "video:duration",
		content: String(e)
	}, "video:duration"), !!t && t?.map((e) => /* @__PURE__ */ w("meta", {
		property: "og:video:tag",
		content: e
	}, e))] })] });
}, $e = ({ twitterCard: e = "summary_large_image", twitterImage: t, twitterDescription: n }) => {
	let r = O(), { Head: i } = r, a = t || r.seoImage.url;
	return /* @__PURE__ */ T(i, { children: [
		/* @__PURE__ */ w("meta", {
			name: "twitter:card",
			content: e
		}),
		/* @__PURE__ */ w("meta", {
			name: "twitter:image",
			content: a
		}, "twitter:image"),
		/* @__PURE__ */ w("meta", {
			property: "twitter:description",
			content: n
		}, "twitter:description")
	] });
}, et = ({ scripts: e = [] }) => {
	let { Head: t } = O();
	return /* @__PURE__ */ w(t, { children: e.map(({ id: e, data: t }) => /* @__PURE__ */ n("script", {
		...t,
		key: e
	})) });
}, tt = (e) => ({
	icon: `${e}/favicon.ico`,
	svg: `${e}/favicon.svg`,
	appleTouchIcon: `${e}/apple-touch-icon.png`,
	appleTouchIcon152: `${e}/apple-touch-icon-152x152.png`,
	appleTouchIcon167: `${e}/apple-touch-icon-167x167.png`,
	appleTouchIcon180: `${e}/apple-touch-icon-180x180.png`
}), nt = () => {
	let { Head: e, hostOrigin: t } = O(), n = tt(t ?? "");
	return /* @__PURE__ */ T(e, { children: [
		/* @__PURE__ */ w("link", {
			rel: "icon",
			href: n.icon,
			sizes: "16x16 32x32 48x48",
			type: "image/x-icon"
		}),
		/* @__PURE__ */ w("link", {
			rel: "icon",
			href: n.svg,
			sizes: "any",
			type: "image/svg+xml"
		}),
		/* @__PURE__ */ w("link", {
			rel: "apple-touch-icon",
			href: n.appleTouchIcon
		}),
		/* @__PURE__ */ w("link", {
			rel: "apple-touch-icon",
			sizes: "152x152",
			href: n.appleTouchIcon152
		}),
		/* @__PURE__ */ w("link", {
			rel: "apple-touch-icon",
			sizes: "167x167",
			href: n.appleTouchIcon167
		}),
		/* @__PURE__ */ w("link", {
			rel: "apple-touch-icon",
			sizes: "180x180",
			href: n.appleTouchIcon180
		})
	] });
}, rt = ({ links: e }) => {
	let { Head: t } = O();
	return /* @__PURE__ */ w(t, { children: e.map((e) => /* @__PURE__ */ w("link", {
		rel: "preload",
		...e
	}, e.href)) });
}, it = ({ seoDefaultValues: e, children: t }) => /* @__PURE__ */ w(Ke.Provider, {
	value: e,
	children: t
}), at = /* @__PURE__ */ me({
	BasicMeta: () => Ye,
	FaviconLinks: () => nt,
	OgVideoMeta: () => Qe,
	OgWebsiteMeta: () => Ze,
	PreloadLinks: () => rt,
	Provider: () => it,
	StructuredData: () => et,
	TwitterMeta: () => $e
}), ot = {
	home_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.c9ca44c0776e1a7a35219eb3c29b1842" }, { brandName: t }),
	home_seo_description: (e) => e.formatMessage({ id: "yango-shared.i18n.c3ee1bbda67aef5101a6a3b5eaeea26e" }),
	music_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.247eaea9c7b59c177155adace28cd307" }, { brandName: t }),
	music_meta_description: (e) => e.formatMessage({ id: "yango-shared.i18n.f119440a78b551b3d71830059cbdae0a" }),
	yasmina_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.75183bf6eff3525e541a3f5b89ea6215" }, { brandName: t }),
	yasmina_meta_description: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.b272833b5b03acfc8a60a7a80702562b" }, { brandName: t }),
	crunchyroll_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.432259e6e890ffddcb9e4a0a971037e4" }, { brandName: t }),
	crunchyroll_meta_description: (e) => e.formatMessage({ id: "yango-shared.i18n.d9c3467b19748eac900efdf403079e81" }),
	cari_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.00f40372932ef576ddede55ffe815fc6" }, { brandName: t }),
	cari_meta_description: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.31bb5fa8d62e447960af5150adb043c9" }, { brandName: t }),
	talabat_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.69ede0a45134e1ee040e337756fe864e" }, { brandName: t }),
	talabat_meta_description: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.e10f5e1d5fee3ccbc50ec44fb7676f46" }, { brandName: t }),
	settings_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.68c59d81e48e440b99a82bdcad8961a1" }, { brandName: t }),
	settings_meta_description: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.9688895733f2180a01790bbedf7c587f" }, { brandName: t }),
	selection__seo_title: (e, { title: t, brandName: n }) => e.formatMessage({ id: "yango-shared.i18n.c7eb6a2b3ae99b848674ba6d9c36ed20" }, {
		title: t,
		brandName: n
	}),
	selection__meta_description: (e, { title: t, brandName: n }) => e.formatMessage({ id: "yango-shared.i18n.097c644db94478882376918ebfad27a2" }, {
		title: t,
		brandName: n
	}),
	person_seo_title: (e, { name: t, brandName: n }) => e.formatMessage({ id: "yango-shared.i18n.61c0cb332e69b16aea91ab6c574103bb" }, {
		name: t,
		brandName: n
	}),
	person_meta_description: (e, { name: t, brandName: n }) => e.formatMessage({ id: "yango-shared.i18n.4a2b1622365c1ede99f508a8d276d67b" }, {
		name: t,
		brandName: n
	}),
	movie__film_seo_title: (e, { title: t, brandName: n }) => e.formatMessage({ id: "yango-shared.i18n.7a62bce6cc9912ff858ce9fcca27d57b" }, {
		title: t,
		brandName: n
	}),
	movie__film_meta_description: (e, { title: t, yearAndCountry: n, brandName: r }) => e.formatMessage({ id: "yango-shared.i18n.8e6dad65dfae6b8e3942b7cc080213aa" }, {
		title: t,
		yearAndCountry: n,
		brandName: r
	}),
	movie__film_seo_year_and_country: (e, { ottProductionYear: t, comma: n, country: r }) => e.formatMessage({ id: "yango-shared.i18n.e992b42b390806724b27faeaaf73168d" }, {
		ottProductionYear: t,
		comma: n,
		country: r
	}),
	movie__series_seo_title: (e, { title: t, brandName: n }) => e.formatMessage({ id: "yango-shared.i18n.5093e6fda1dcfbcac8dc2566c70be304" }, {
		title: t,
		brandName: n
	}),
	movie__series_meta_description: (e, { title: t, years: n, brandName: r }) => e.formatMessage({ id: "yango-shared.i18n.11455b8a68f1719fcc4d377f81367677" }, {
		title: t,
		years: n,
		brandName: r
	}),
	channels_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.197a4c17d41a7616ff16d048a4e73281" }, { brandName: t }),
	channels_meta_description: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.da762b9acab6aba6c1843a0455d7db9b" }, { brandName: t }),
	history_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.81189435bb53a57af303dc2ab7ea7473" }, { brandName: t }),
	history_meta_description: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.75cd3553ced0fa9ea3c5261c3725fd64" }, { brandName: t }),
	personal_collection_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.641d5ca4a091775c74cc25366426da0e" }, { brandName: t }),
	personal_collection_meta_description: (e) => e.formatMessage({ id: "yango-shared.i18n.2268bd9c28cfeb283da1c836ac0e4e6b" }),
	profiles_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.064bb4b609654f4c4161e334d06ff9a9" }, { brandName: t }),
	profiles_meta_description: (e) => e.formatMessage({ id: "yango-shared.i18n.7de5a32eb16b914f8c63f98cbe48d341" }),
	admin_add_seo_title: (e, { brandName: t }) => e.formatMessage({ id: "yango-shared.i18n.37ac7ab3ce71b2288486d2c8ed1fd011" }, { brandName: t }),
	admin_add_meta_description: (e) => e.formatMessage({ id: "yango-shared.i18n.fcfecb380c0f126e150722e79cffa0b9" })
};
//#endregion
//#region src/lib/i18n.ts
function st(e) {
	return function() {
		let t = te();
		return a((n, r) => e[n](t, r), [t]);
	};
}
//#endregion
//#region src/hooks/useI18n.ts
var ct = st(ot);
//#endregion
//#region ../../../../../../../../../../../../home/sandbox/.nots/pnpm_store/v10/links/@/clsx/2.1.1/31a8239809d68b055357418aaab3ba5139c779aca23636c4138978433c48d592/node_modules/clsx/dist/clsx.mjs
function lt(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") if (Array.isArray(e)) {
		var i = e.length;
		for (t = 0; t < i; t++) e[t] && (n = lt(e[t])) && (r && (r += " "), r += n);
	} else for (n in e) e[n] && (r && (r += " "), r += n);
	return r;
}
function A() {
	for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = lt(e)) && (r && (r += " "), r += t);
	return r;
}
//#endregion
//#region src/hooks/useOuterClick.ts
function ut(e, t, n = !0) {
	o(() => {
		if (!n) return;
		let r = (n) => {
			e.current && !e.current.contains(n.target) && t();
		};
		return document.addEventListener("mousedown", r), () => {
			document.removeEventListener("mousedown", r);
		};
	}, [
		e,
		t,
		n
	]);
}
var j = {
	root: "Tooltip_root__Ousxt",
	startAlignment: "Tooltip_startAlignment__AYXDx",
	withChevronOnLeft: "Tooltip_withChevronOnLeft__EOTB6",
	tail: "Tooltip_tail__5MxPN",
	middleAlignment: "Tooltip_middleAlignment__YW_ZG",
	endAlignment: "Tooltip_endAlignment__2TtM4",
	withChevronOnRight: "Tooltip_withChevronOnRight__5gkYR",
	closeButton: "Tooltip_closeButton__H-hBL",
	withChevronAtTop: "Tooltip_withChevronAtTop__XE3lV",
	withChevronAtBottom: "Tooltip_withChevronAtBottom__rA6ck",
	secondary: "Tooltip_secondary__CBLfl",
	portal: "Tooltip_portal__braRe",
	tooltipSlideIn: "Tooltip_tooltipSlideIn__2Th2l",
	text: "Tooltip_text__C73oL"
}, dt = (e) => /* @__PURE__ */ w("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "2.4rem",
	height: "2.4rem",
	fill: "none",
	viewBox: "0 0 24 24",
	...e,
	children: /* @__PURE__ */ w("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12 21.5a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19m2.652-13.849L12 10.303 9.349 7.65 7.65 9.35 10.303 12 7.65 14.652l1.698 1.697L12 13.697l2.652 2.652 1.697-1.697L13.697 12l2.652-2.651z",
		clipRule: "evenodd"
	})
}), ft = (e) => /* @__PURE__ */ w("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "2.4rem",
	height: "1rem",
	fill: "none",
	viewBox: "0 0 24 10",
	...e,
	children: /* @__PURE__ */ w("path", {
		fill: "currentColor",
		d: "M9.839 1.044c1.092-1.392 3.23-1.392 4.322 0l4.043 5.155A7.36 7.36 0 0 0 24 9v1H0V9a7.36 7.36 0 0 0 5.796-2.8z"
	})
}), M = /* @__PURE__ */ function(e) {
	return e.Text = "tooltip.text", e.CloseButton = "tooltip.closeButton", e;
}(M || {});
function pt(e) {
	return e === "start" ? "end" : e === "end" ? "start" : e;
}
function mt(e) {
	switch (e) {
		case "top": return "bottom";
		case "bottom": return "top";
		case "left": return "right";
		case "right": return "left";
		default: return e;
	}
}
var ht = {
	left: j.withChevronOnLeft,
	right: j.withChevronOnRight,
	top: j.withChevronAtTop,
	bottom: j.withChevronAtBottom
}, gt = {
	start: j.startAlignment,
	middle: j.middleAlignment,
	end: j.endAlignment
};
function _t(e, t, n, r) {
	let i = e.left + window.scrollX, a = i + e.width / 2, o = e.top + e.height / 2 + window.scrollY, s = {
		position: "absolute",
		right: "auto"
	}, c = {
		...s,
		top: o
	}, l = {
		...s,
		left: r ? i : a,
		width: r ? e.width : void 0
	};
	switch (t) {
		case "top": return {
			...l,
			top: e.top + window.scrollY - n,
			transform: r ? "translateY(-100%)" : "translate(-50%, -100%)"
		};
		case "bottom": return {
			...l,
			top: e.bottom + window.scrollY + n,
			transform: r ? void 0 : "translateX(-50%)"
		};
		case "left": return {
			...c,
			left: i - n,
			transform: "translate(-100%, -50%)"
		};
		case "right": return {
			...c,
			left: e.right + window.scrollX + n,
			transform: "translateY(-50%)"
		};
		default: return s;
	}
}
var vt = ({ children: e, visible: t, direction: n = "bottom", alignment: r = "end", className: i, ariaHidden: a, closeLabel: s, withOuterClick: c = !0, showCloseButton: l = !0, onCloseClick: f, viewVariant: p, anchorRef: m, inheritWidth: h = !0, mainOffset: g = 10, ..._ }) => {
	let [v, y] = d(t), b = u(null), [x, ee] = d({}), S = mt(n), C = pt(r);
	if (o(() => {
		!m?.current || !t || ee(_t(m.current.getBoundingClientRect(), n, g, h));
	}, [
		m,
		t,
		n,
		h,
		g
	]), ut(b, () => {
		y(!1), f?.();
	}, c && v), !v || !t) return null;
	let E = /* @__PURE__ */ T("div", {
		ref: b,
		className: A(i, j.root, ht[S], gt[C], p === "secondary" && j.secondary, m && j.portal),
		style: m ? x : void 0,
		"aria-hidden": a,
		..._,
		children: [
			/* @__PURE__ */ w(ft, { className: j.tail }),
			/* @__PURE__ */ w("span", {
				"data-testid": M.Text,
				className: j.text,
				children: e
			}),
			l && /* @__PURE__ */ w("button", {
				"data-testid": M.CloseButton,
				onClick: () => {
					f?.(), y(!1);
				},
				type: "button",
				className: j.closeButton,
				"aria-label": s,
				children: /* @__PURE__ */ w(dt, {})
			})
		]
	});
	return m ? ne(E, document.body) : E;
}, N = {
	ae: "+000 (00) 000 0000",
	ae_zero: "+000 (0) 00 000 0000",
	bh: "+000 0000 0000",
	eg: "+00 (000) 000 0000",
	jo: "+000 (0) 0000 0000",
	kw: "+000 0000 0000",
	om: "+000 (00) 000000",
	qa: "+000 0000 0000",
	sa_without_zero: "+000 (00) 000 0000",
	sa_with_zero: "+000 (000) 000 0000",
	universal: "+000 000 000 000"
}, yt = [
	{
		mask: N.eg,
		startsWith: "20"
	},
	{
		mask: N.bh,
		startsWith: "973"
	},
	{
		mask: N.jo,
		startsWith: "962"
	},
	{
		mask: N.kw,
		startsWith: "965"
	},
	{
		mask: N.sa_with_zero,
		startsWith: "9660"
	},
	{
		mask: N.sa_without_zero,
		startsWith: "966"
	},
	{
		mask: N.om,
		startsWith: "968"
	},
	{
		mask: N.ae_zero,
		startsWith: "9710"
	},
	{
		mask: N.ae,
		startsWith: "971"
	},
	{
		mask: N.qa,
		startsWith: "974"
	},
	{
		mask: N.universal,
		startsWith: ""
	}
], bt = {
	ae: "971",
	bh: "973",
	eg: "20",
	jo: "962",
	kw: "965",
	om: "968",
	qa: "974",
	sa: "966"
}, xt = (e, t) => {
	let n = P(e);
	if (n === "") {
		if (t) {
			let e = bt[t.toLowerCase()];
			if (e) {
				let t = yt.find(({ startsWith: t }) => e.startsWith(t));
				if (t) {
					let e = 15 - P(t.mask).length;
					return {
						mask: t.mask + Array(Math.max(e, 0)).fill("0").join(""),
						placeholder: t.mask
					};
				}
			}
		}
		return {
			mask: N.universal,
			placeholder: N.universal
		};
	}
	let r = yt.find(({ startsWith: e }) => n.startsWith(e));
	if (!r) return {
		mask: N.universal,
		placeholder: N.universal
	};
	let i = 15 - P(r.mask).length;
	return {
		mask: r.mask + Array(Math.max(i, 0)).fill("0").join(""),
		placeholder: r.mask
	};
}, St = (e, t) => {
	let n = P(e), r = "", i = 0;
	for (let e = 0; e < t.length && i < n.length; e++) t[e] === "0" ? (r += n[i], i += 1) : r += t[e];
	return r;
}, P = (e) => e.replace(/[^0-9]+/g, ""), Ct = (e) => {
	let t = P(e);
	return t ? t.startsWith("971") ? "ae" : t.startsWith("973") ? "bh" : t.startsWith("20") ? "eg" : t.startsWith("962") ? "jo" : t.startsWith("965") ? "kw" : t.startsWith("968") ? "om" : t.startsWith("974") ? "qa" : t.startsWith("966") ? "sa" : "" : "";
}, wt = (e) => bt[e.toLowerCase()] || "", Tt = (e) => {
	let { phone: t, getCurrentIso2: n, handleChange: r, handleClear: i } = f(() => {
		let t = S(""), n = "", r = !1;
		if (e) {
			let i = wt(e);
			if (i) {
				let a = xt(i, e);
				n = e, t.set(St(i, a.mask)), r = !0;
			}
		}
		let i = () => t.get() ? n || "" : r ? "" : e || "";
		return {
			phone: t.seal(),
			internalIso2: n,
			isInitialized: r,
			getCurrentIso2: i,
			handleChange: (e) => {
				let a = P(e.target.value);
				if (a.length <= 15) {
					let e = Ct(a), o = i(), s = St(a, xt(a, e || o).mask);
					t.set(s), s ? (n = e || "", r = !0) : n = "";
				}
			},
			handleClear: () => {
				t.set(""), n = "";
			}
		};
	});
	return {
		phone: _(t),
		iso2: n(),
		handleChange: r,
		handleClear: i
	};
}, F = {
	root: "PhoneInput_root__jwej0",
	field: "PhoneInput_field__mJyzy",
	flagButton: "PhoneInput_flagButton__OtkpH",
	inputWrapper: "PhoneInput_inputWrapper__IqZuD",
	mask: "PhoneInput_mask__8CAxG",
	maskVisible: "PhoneInput_maskVisible__GU4oW",
	input: "PhoneInput_input__yyXx4",
	clearButton: "PhoneInput_clearButton__dzWj9"
}, I = {
	flagContainer: "CountryFlag_flagContainer__GcbDg",
	flagEmoji: "CountryFlag_flagEmoji__U-5JC",
	flagGlobe: "CountryFlag_flagGlobe__YtlA9"
}, Et = (e) => {
	let t = e.toUpperCase().split("").map((e) => 127397 + e.charCodeAt(0));
	return String.fromCodePoint(...t);
}, Dt = ({ iso2: e }) => {
	if (!e) return /* @__PURE__ */ w("div", {
		className: I.flagContainer,
		children: /* @__PURE__ */ w("span", { className: I.flagGlobe })
	});
	let t = Et(e);
	return /* @__PURE__ */ w("div", {
		className: I.flagContainer,
		children: /* @__PURE__ */ w("span", {
			className: I.flagEmoji,
			children: t
		})
	});
}, Ot = r(({ iso2: e, closeIcon: t }, n) => {
	let r = u(null), { phone: i, iso2: a, handleChange: o, handleClear: c } = Tt(e), [l, f] = d(!1);
	s(n, () => ({ getValue: () => i }));
	let p = xt(i, a), m = i.length >= p.placeholder.length, h = i && (l || m);
	return /* @__PURE__ */ w("div", {
		className: F.root,
		children: /* @__PURE__ */ T("label", {
			className: A(F.field, (i || a) && F.fieldHasValue),
			children: [
				/* @__PURE__ */ w("div", {
					className: F.flagButton,
					children: /* @__PURE__ */ w(Dt, { iso2: a })
				}),
				/* @__PURE__ */ T("div", {
					className: F.inputWrapper,
					children: [/* @__PURE__ */ T("div", {
						className: F.mask,
						"aria-hidden": "true",
						children: [i, /* @__PURE__ */ w("span", {
							className: F.maskVisible,
							children: p.placeholder.slice(i.length)
						})]
					}), /* @__PURE__ */ w("input", {
						ref: r,
						type: "tel",
						inputMode: "tel",
						className: F.input,
						value: i,
						onChange: o,
						onFocus: () => f(!0),
						onBlur: () => f(!1),
						"data-testid": "phone-input"
					})]
				}),
				h && /* @__PURE__ */ w("div", {
					className: F.clearButton,
					children: t && t(c)
				})
			]
		})
	});
}), kt = ({ className: e }) => {
	let t = `2023\u2013${(/* @__PURE__ */ new Date()).getFullYear()}`;
	return /* @__PURE__ */ T("span", {
		className: e,
		"data-tid": "Copyright",
		children: [
			/* @__PURE__ */ w("bdo", {
				dir: "ltr",
				children: "©"
			}),
			"\xA0",
			/* @__PURE__ */ w("bdo", {
				dir: "ltr",
				children: t
			}),
			"\xA0",
			/* @__PURE__ */ w("bdo", {
				dir: "ltr",
				children: "Funtech Loyalty Card Services LLC"
			}),
			/* @__PURE__ */ w("bdo", {
				dir: "ltr",
				children: ", "
			}),
			/* @__PURE__ */ w("bdo", {
				dir: "ltr",
				children: "18+"
			})
		]
	});
}, L = {
	root: "FooterComponent_root__NVCL5",
	touch: "FooterComponent_touch__zwuS9",
	divider: "FooterComponent_divider__FIgBX",
	sections: "FooterComponent_sections__2XX5K",
	sectionTitle: "FooterComponent_sectionTitle__fGzGH",
	linksList: "FooterComponent_linksList__wB5_k",
	link: "FooterComponent_link__UAFt8",
	socialLinks: "FooterComponent_socialLinks__zzFsc",
	socialLink: "FooterComponent_socialLink__dxorv",
	copyright: "FooterComponent_copyright__Ftt3w",
	emptySpace: "FooterComponent_emptySpace__N3101",
	section: "FooterComponent_section__KuhBv",
	copyrightDivider: "FooterComponent_copyrightDivider__5HiaM"
}, At = ({ sections: e, socialLinks: t, RouterLink: n, isTouch: r, i18nGeoWidgetEnabled: i, i18nGeoWidgetBrand: a = "yango" }) => /* @__PURE__ */ T("footer", {
	className: A(L.root, { [L.touch]: r }),
	"data-tid": "FooterComponent",
	children: [
		/* @__PURE__ */ w("div", { className: L.divider }),
		/* @__PURE__ */ T("div", {
			className: L.sections,
			children: [e.map((e) => /* @__PURE__ */ T("div", {
				className: L.section,
				children: [/* @__PURE__ */ w("h3", {
					className: L.sectionTitle,
					children: e.title
				}), /* @__PURE__ */ w("ul", {
					className: L.linksList,
					children: e.links.map((e) => /* @__PURE__ */ w("li", { children: "location" in e ? /* @__PURE__ */ w(n, {
						to: e.location,
						className: L.link,
						children: e.text
					}) : /* @__PURE__ */ w("a", {
						href: e.href,
						className: L.link,
						target: "_blank",
						rel: "noreferrer",
						children: e.text
					}) }, e.text))
				})]
			}, e.title)), /* @__PURE__ */ w("div", {
				className: L.socialLinks,
				children: t.map(({ link: e, renderIcon: t, label: n }) => /* @__PURE__ */ w("a", {
					href: e,
					className: L.socialLink,
					target: "_blank",
					rel: "noreferrer",
					"aria-label": n,
					children: t()
				}, e))
			})]
		}),
		/* @__PURE__ */ w("div", { className: L.copyrightDivider }),
		/* @__PURE__ */ w(re, {
			enabled: i,
			brand: a,
			environment: "production",
			lang: "en",
			theme: "dark",
			children: /* @__PURE__ */ w(kt, { className: L.copyright })
		}),
		r && /* @__PURE__ */ w("div", { className: L.emptySpace })
	]
}), R = x("remoteConfig");
function jt(e) {
	let t = b(e);
	return {
		get flags() {
			return t;
		},
		ref: () => R,
		hydrate(e) {
			t = b(e);
		},
		toJSON: () => t.toJSON()
	};
}
//#endregion
//#region src/hooks/useRemoteConfig.ts
function Mt(e) {
	let t = y(R);
	return l(() => e ? e.apply(t.flags) : t, [t, e]);
}
//#endregion
//#region src/lib/requestId.ts
function Nt(e, t) {
	if (e == null) throw Error(`${t} is not initialized`);
}
var Pt = x("requestIdManager");
function Ft(e) {
	let t, n = e?.traceparent || "";
	return typeof window > "u" && (t = ae(oe(e?.requestId), { parser: se })), {
		get requestId() {
			return Nt(t, "requestId"), t;
		},
		get traceparent() {
			return n;
		},
		ref() {
			return Pt;
		},
		hydrate(e) {
			t = ae(e.requestId, { parser: ie }), n = e.traceparent;
		},
		toJSON() {
			return {
				requestId: this.requestId.root,
				traceparent: n
			};
		}
	};
}
//#endregion
//#region src/components/Picture/Picture.tsx
var It = ({ sources: e, src: t, srcSet: n, alt: r, className: i, width: a, height: o, loading: s, decoding: c, id: l, title: u, role: d, sizes: f, onError: p, onLoad: m, "data-tid": h }) => {
	let g = /* @__PURE__ */ w("img", {
		id: l,
		"data-tid": h,
		className: i,
		src: t,
		srcSet: n,
		alt: r,
		role: d,
		width: a,
		height: o,
		loading: s,
		decoding: c,
		title: u,
		sizes: f,
		onLoad: m,
		onError: p
	});
	return e && e.length > 0 ? /* @__PURE__ */ T("picture", { children: [e.map(({ srcSet: e, media: t, type: n, sizes: r }, i) => /* @__PURE__ */ w("source", {
		srcSet: e,
		media: t,
		type: n,
		sizes: r
	}, `${e || "source"}-${t || i}`)), g] }) : g;
}, Lt = "(max-width: 599px)", Rt = "(min-width: 600px)";
function zt(e) {
	return e && /\/orig$/.test(e) ? e.replace("/orig", "").replace(/^.*?:\/\//, "//") : e;
}
var Bt = (e, t) => Object.entries(t).map(([t, n]) => `${e}/${n} ${t}`).join(", ");
function z(e, t) {
	return t ? `${e}/${t}` : e;
}
var Vt = (e) => e?.map(({ media: e, width: t }) => e ? `${e} ${t}` : t).join(", "), Ht = (e, t) => {
	if (!(!e || t == null)) return typeof t == "string" ? z(e, t) : Bt(e, t);
}, Ut = (e) => {
	let t = {
		...e,
		...e.mobile && !e.mobile.media ? { mobile: {
			...e.mobile,
			media: Lt
		} } : {},
		...e.tablet && !e.tablet.media ? { tablet: {
			...e.tablet,
			media: Rt
		} } : {}
	};
	return (e) => {
		let n = Object.fromEntries(Object.entries(e).map(([e, t]) => [e, t && zt(t)])), r = [], i = [], a = t.fallback, { fallbackUrl: o } = n, s = {
			src: o && a ? z(o, a.src) : void 0,
			srcSet: o && a ? Ht(o, a.srcSet) : void 0,
			sizes: a ? Vt(a.sizes) : void 0
		};
		return Object.keys(t).forEach((e) => {
			let a = t[e], o = n[`${e}Url`];
			if (a && o && typeof a.srcSet == "object" && e !== "fallback") {
				let e = a.srcSet ? Bt(o, a.srcSet) : void 0, t = a.href ? z(o, a.href) : void 0;
				r.push({
					media: a.media,
					type: a.type,
					srcSet: e,
					sizes: Vt(a.sizes)
				}), i.push({
					media: a.media,
					href: t,
					imageSrcSet: e
				});
			}
		}), {
			sources: r,
			img: s,
			preloadLinks: i
		};
	};
};
//#endregion
//#region src/lib/featureFlags.ts
function Wt(e) {
	let t = {}, n = {};
	return e.forEach(({ source: e, values: r }) => {
		Object.entries(r ?? {}).forEach(([r, i]) => {
			t[r] = i, n[r] = e;
		});
	}), {
		flags: t,
		sources: n
	};
}
var Gt = x("featureFlags");
function Kt(e) {
	let t = b(), n = {}, r = [], i = {}, a = [];
	e && o(e);
	function o(e) {
		if (Array.isArray(e.flags)) {
			let r = Wt(e.flags);
			t = b(r.flags), n = r.sources;
		} else t = b(e.flags), n = e.sources ?? {};
		r = e.testIds || [], i = e.grouped || {}, a = e.rumSlots || [];
	}
	return {
		get flags() {
			return t;
		},
		get sources() {
			return n;
		},
		get testIds() {
			return r;
		},
		get grouped() {
			return i;
		},
		get rumSlots() {
			return a;
		},
		ref: () => Gt,
		hydrate: o,
		toJSON() {
			return {
				flags: t.toJSON(),
				sources: n,
				testIds: r,
				grouped: i,
				rumSlots: a
			};
		}
	};
}
//#endregion
//#region src/hooks/useFeatureFlags.ts
function qt(e) {
	let t = y(Gt);
	return l(() => e ? {
		...t,
		flags: e.apply(t.flags)
	} : t, [t, e]);
}
//#endregion
//#region src/lib/featureFlagsOverride.ts
var Jt = "ff_";
function Yt(e, t = Jt) {
	return [...e.entries()].reduce((e, [n, r]) => {
		if (!n.startsWith(t) || n.length === t.length) return e;
		let i = n.slice(t.length);
		try {
			e[i] = JSON.parse(r);
		} catch {
			e[i] = r;
		}
		return e;
	}, {});
}
//#endregion
//#region src/lib/schema.ts
var B = class e extends Error {
	name = "SchemeError";
	parseStack;
	constructor(t) {
		super(t.message), this.parseStack = [t.message], t.error instanceof e && this.parseStack.push(...t.error.parseStack);
	}
};
function Xt(e) {
	return "optional" in e;
}
function V(e) {
	function t(t) {
		return { parse(n) {
			return n === void 0 ? t : e(n);
		} };
	}
	return {
		parse: e,
		optional: t
	};
}
function Zt(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
var Qt = V((e) => {
	if (e === "true" || e === "1" || e === !0) return !0;
	if (e === "false" || e === "0" || e === !1) return !1;
	throw new B({ message: "Value is not a valid boolean" });
}), $t = V((e) => {
	if (typeof e == "string") return e;
	throw new B({ message: "Value is not a string" });
}), en = V((e) => {
	let t = typeof e == "string" && e.trim() !== "" ? Number(e) : e;
	if (typeof t == "number" && !Number.isNaN(t) && Number.isFinite(t)) return t;
	throw new B({ message: "Value is not a valid number" });
});
function tn(e) {
	let t = new Set(e);
	return V((e) => {
		if (t.has(e)) return e;
		throw new B({ message: "Value is not a valid enum value" });
	});
}
function nn(e) {
	return V((t) => {
		if (!Array.isArray(t)) throw new B({ message: "Value is not an array" });
		return t.map((t) => e.parse(t));
	});
}
function rn(e) {
	return V((t) => {
		if (!Zt(t)) throw new B({ message: "Value is not an object" });
		return Object.fromEntries(Object.entries(t).map(([t, n]) => [t, e.parse(n)]));
	});
}
function an(e) {
	return V((t) => {
		if (!Zt(t)) throw new B({ message: "Value is not an object" });
		let n = Object.keys(e).map((n) => {
			let r = e[n];
			try {
				return [n, r.parse(t[n])];
			} catch (e) {
				throw new B({
					message: `Cannot parse object key="${n}"`,
					error: e
				});
			}
		});
		return Object.fromEntries(n);
	});
}
var on = {
	boolean: Qt,
	string: $t,
	number: en,
	enum: tn,
	arrayOf: nn,
	mapOf: rn,
	create: an
};
//#endregion
//#region src/lib/flagsScheme.ts
function sn(e) {
	return { apply(t) {
		return { get(n) {
			let r = e[n], i = t.get(n);
			try {
				return r.parse(i);
			} catch (e) {
				let t = String(n), a = e instanceof Error ? e.message : String(e);
				if (Xt(r)) throw Error(`Scheme for "${t}" failed: ${a}${i === void 0 ? " — declare a default via .optional()" : ""}`);
				return r.parse(void 0);
			}
		} };
	} };
}
//#endregion
//#region src/lib/script.ts
var H = (e, t = document.body, n = {}, r = void 0) => new Promise((i, a) => {
	let o = document.createElement("script");
	o.type = "text/javascript", o.src = e, o.onload = i, o.onerror = a, Object.keys(n).forEach((e) => {
		let t = n[e];
		typeof t == "string" && o.setAttribute(e, t), typeof t == "boolean" && o.setAttribute(e, "");
	}), r ? t.insertAdjacentElement(r, o) : t.appendChild(o);
}), U = {}, cn = async (e, ...t) => {
	if (e in U) {
		let t = U[e];
		if (t) return Promise.resolve(t);
	}
	let n = await H(e, ...t);
	return U[e] = n, n;
};
async function ln(e, t, n) {
	let { to: r = document.body, params: i = {}, errorMessage: a = `Script "${e}" load error` } = t || {}, o;
	try {
		o = await H(e, r, i);
	} catch (e) {
		throw e instanceof Error && n.error({ error: e }, a), e;
	}
	return o;
}
//#endregion
//#region src/lib/gtm.ts
var un = [
	"utm_source",
	"utm_medium",
	"utm_campaign",
	"utm_term",
	"utm_content"
], dn = [
	"gclid",
	"fbclid",
	"yclid",
	"ttclid",
	"rb_clickid"
], fn = [...un, ...dn], W = "dataLayer", G = globalThis, pn = x("gtmService");
function mn({ logger: e, trackedQueryParamsStore: t, nonce: n }) {
	let r, i, a = !1, o, s = n ?? "", c;
	async function l(t) {
		if (!t.containerId) {
			e.error("You must specify `container` query parameter for GTM!");
			return;
		}
		if (a) return;
		G[W] || (G[W] = []), c = t.source, a = !0, i = t.containerId, r = t.userId, o = G[W], o.push({ data_layer_nonce: s }), o.push({
			"gtm.start": (/* @__PURE__ */ new Date()).getTime(),
			event: "gtm.js"
		});
		let n = new URL("https://www.googletagmanager.com/gtm.js");
		n.searchParams.set("id", i), n.searchParams.set("l", W);
		try {
			await cn(n.toString(), document.head, {
				async: !0,
				nonce: s
			}, "afterbegin");
		} catch (t) {
			e.error({ error: t }, "GTM load failed");
		}
		o.push(u());
	}
	function u() {
		return {
			source: c,
			container: i,
			...t?.getParams(fn)
		};
	}
	function d(e) {
		if (!r || !o) return;
		let t = {
			source: c,
			container: i,
			...u(),
			...e,
			userId: r
		};
		o.push(t);
	}
	return {
		initialize: l,
		send: d,
		ref: () => pn,
		hydrate: (e) => {
			s = e;
		},
		toJSON: () => s
	};
}
//#endregion
//#region src/hooks/useGtmService.ts
function hn() {
	return p(pn);
}
//#endregion
//#region src/lib/metrika/api.ts
var K = "yandex_metrika_callbacks2", gn = 2e3, _n = 3, vn = 1e3;
function yn({ initialParams: e, scriptSrc: t, logger: n }) {
	let r = null, i = [], a = () => window.Ya?.Metrika2, o = () => new Promise((e, n) => {
		let r = a();
		if (r) {
			e(r);
			return;
		}
		let i = setTimeout(n, gn);
		Array.isArray(window[K]) || (window[K] = []), window[K].push(() => {
			clearTimeout(i);
			let t = a();
			t ? e(t) : n();
		}), cn(t, document.body, { async: !0 }).catch(() => {
			clearTimeout(i), n();
		});
	}), s = async (e = 1) => {
		try {
			return await o();
		} catch (r) {
			if (e >= _n) {
				n?.warn({
					error: r,
					scriptSrc: t,
					attempt: e
				}, "Metrika tag load failed");
				return;
			}
			return await new Promise((e) => {
				setTimeout(e, vn);
			}), s(e + 1);
		}
	}, c = (e) => {
		if (r) try {
			switch (e.type) {
				case "params":
					r.params(...e.payload);
					break;
				case "reachGoal":
					r.reachGoal(...e.payload);
					break;
				default: break;
			}
		} catch (e) {
			n?.error({ error: e }, "Metrika event handling failed");
		}
	};
	return (async () => {
		let t = await s();
		t && (r = new t(e), i.forEach((e) => {
			c(e);
		}), i = []);
	})(), { emit: (e) => {
		r ? c(e) : i.push(e);
	} };
}
//#endregion
//#region src/lib/metrika/createMetrikaService.ts
var bn = [
	"utm_source",
	"utm_medium",
	"utm_campaign",
	"utm_term",
	"utm_content"
], xn = x("metrikaService"), Sn = (e) => {
	let t = new URL(window.location.href), n = e?.getParams(bn) ?? {};
	return Object.entries(n).forEach(([e, n]) => {
		t.searchParams.set(e, String(n));
	}), t.toString();
};
function Cn({ counter: e, scriptSrc: t, logger: n, trackedQueryParamsStore: r }) {
	let i = null;
	return typeof window < "u" && (i = yn({
		initialParams: {
			...e,
			url: Sn(r)
		},
		scriptSrc: t,
		logger: n
	})), {
		trackEvent: (e, t) => i?.emit({
			type: "params",
			payload: [{ [e]: t }]
		}),
		reachGoal: (e, t) => i?.emit({
			type: "reachGoal",
			payload: [e, t]
		}),
		ref: () => xn
	};
}
//#endregion
//#region src/hooks/useMetrikaService.ts
function wn() {
	return p(xn);
}
//#endregion
//#region src/lib/queryParams.ts
var Tn = "query_params", En = () => typeof window > "u" ? {} : Object.fromEntries(new URLSearchParams(window.location.search)), Dn = (e, t) => t.length === 0 ? e : t.reduce((t, n) => {
	let r = e[n];
	return r && (t[n] = r), t;
}, {}), On = x("queryParamsStore");
function kn(e) {
	let { storage: t, storageKey: n = Tn } = e, r = t.get(n) ?? {};
	function i(e) {
		Object.keys(e).length !== 0 && t.set(n, e) && (r = e);
	}
	function a() {
		return Object.keys(r).length === 0 && i(En()), r;
	}
	function o(e) {
		return Dn(r, e);
	}
	return {
		getParams: o,
		initialize: a,
		ref: () => On
	};
}
//#endregion
//#region src/hooks/useQueryParamsStore.ts
function An() {
	return p(On);
}
//#endregion
//#region src/lib/lazyFactory.ts
function q(e) {
	let t, n = !1;
	return (...r) => (n ||= (t = e(...r), !0), t);
}
//#endregion
//#region src/lib/payments/offers.ts
var J = (e = []) => e.reduce((e, t) => {
	let n = Number(t);
	return Number.isInteger(n) && e.push(n), e;
}, []), jn = (e = {}) => Object.keys(e).filter((t) => !!e[t]);
function Y(e, t) {
	let n = e.analyticData?.batchId, r = e.analyticData?.positionId, i = e.catalogCompositeOffer?.tariffOffer?.name, a = e.catalogCompositeOffer?.optionOffers?.[0]?.name;
	return {
		...e,
		eventSessionId: t,
		offerPositionsData: n ? { offersBatchId: { [n]: { offersPositionIds: [r] } } } : {},
		billingProductIds: `${i || "NONE"}, ${a || "NONE"}`
	};
}
var Mn = async (e, t) => {
	let { page: n, places: r, extraParams: i } = t, { sessionId: a, result: o } = await e.getBestOffers(n, r, i);
	return r.map((e) => {
		let t = o[e];
		return !t || t.target === null ? null : Y(t, a ?? "");
	}).filter((e) => e !== null);
}, Nn = async (e, t) => {
	let { page: n, places: r, extraParams: i } = t, { sessionId: a, result: o } = await e.getCarouselOffers(n, r, i), s = {};
	return Object.keys(o).forEach((e) => {
		s[e] = (o[e] ?? []).map((e) => Y(e, a ?? ""));
	}), s;
}, Pn = async (e, t) => {
	let { target: n, features: r, extraParams: i } = t, a = {
		target: n,
		features: r
	}, { sessionId: o, result: s } = await e.getBestOffers([a], i), c = s.get(a) ?? null;
	return c ? [Y(c, o ?? "")] : [];
}, Fn = async (e, t) => {
	let { featureTargets: n, extraParams: r } = t, i = n.map(({ target: e, billingFeatureName: t }) => ({
		target: e,
		features: [t]
	})), { sessionId: a, result: o } = await e.getBestOffers(i, r);
	return i.map((e) => {
		let t = o.get(e) ?? null;
		return t ? Y(t, a ?? "") : null;
	}).filter((e) => e !== null);
};
function In(e, { featureFlags: t, logger: n }) {
	let r = e(), i = {
		expTestIds: J(t.testIds),
		expFlags: jn(t.flags.toJSON())
	};
	async function a(e) {
		try {
			return "featureTargets" in e ? await Fn(r, {
				featureTargets: e.featureTargets,
				extraParams: {
					...i,
					...e.extraParams
				}
			}) : "target" in e ? await Pn(r, {
				target: e.target,
				features: e.features,
				extraParams: {
					...i,
					...e.extraParams
				}
			}) : await Mn(r, {
				places: e.places,
				page: e.page,
				extraParams: {
					...i,
					...e.extraParams
				}
			});
		} catch (t) {
			throw t instanceof Error && n.error({
				error: t,
				params: e
			}, "Failed to get offers"), t;
		}
	}
	async function o(e) {
		try {
			let t = {
				...i,
				...e.extraParams
			};
			return await Nn(r, {
				places: e.places,
				page: e.page,
				extraParams: t
			});
		} catch (t) {
			throw t instanceof Error && n.error({
				error: t,
				params: e
			}, "Failed to get offers carousel"), t;
		}
	}
	return {
		getOffers: a,
		getOffersCarousel: o
	};
}
//#endregion
//#region src/lib/disposable.ts
function Ln() {
	let e = /* @__PURE__ */ new Set(), t = !1;
	return {
		get disposed() {
			return t;
		},
		add(n) {
			return t ? (n(), () => {}) : (e.add(n), () => {
				e.delete(n);
			});
		},
		dispose() {
			if (t) return;
			t = !0;
			let n = Array.from(e).reverse();
			e.clear();
			let r = [];
			if (n.forEach((e) => {
				try {
					e();
				} catch (e) {
					r.push(e);
				}
			}), r.length === 1) throw r[0];
			if (r.length > 1) {
				let e = /* @__PURE__ */ Error("Multiple disposal errors");
				throw Object.assign(e, { errors: r }), e;
			}
		}
	};
}
//#endregion
//#region src/lib/payments/widget.ts
function Rn(e, t, n, r) {
	return new ue(e, {
		eventSessionId: t,
		offersBatchId: n,
		offersPositionIds: [r],
		theme: e.options.theme
	});
}
var zn = (e, { onClose: t, onPurchaseSuccess: n, onPurchaseError: r, onError: i, onLoad: a, onScenarioChange: o, onSuccessClose: s, onNeedAuth: c }) => {
	let l = !1;
	return e.on("*", (e) => {
		switch (e.name) {
			case "close":
				t?.(), l &&= (s?.(), !1);
				break;
			case "purchase-success":
				l = !0, n?.(e);
				break;
			case "purchase-error":
				r?.(e);
				break;
			case "error":
				i?.(e);
				break;
			case "page-mount":
				o?.(e.data.scenario);
				break;
			case "load":
				a?.();
				break;
			case "need-auth":
				c?.();
				break;
			default: break;
		}
	});
};
function Bn(e, t) {
	e.setAttribute("aria-hidden", String(t));
}
function Vn(e, t) {
	e.setAttribute("data-scenario", t);
}
function Hn(e, t, n) {
	let { eventSessionId: r, batchId: i, positionId: a } = n, o = Rn(e, r, i, a), s;
	return {
		destroy() {
			s?.(), o.destroy(), o.unmount();
		},
		async mount(e, n, r) {
			try {
				return s = zn(o, {
					...r,
					onLoad: () => {
						Bn(n, !1), r.onLoad?.();
					},
					onClose: () => {
						Bn(n, !0), r.onClose?.();
					}
				}), o.setOnScenarioChange((e) => {
					Vn(n, e), r.onScenarioChange?.(e);
				}), await o.mount({
					offer: e,
					targetNode: n
				});
			} catch (e) {
				throw e instanceof Error && t.error({ error: e }, "Couldn't open payment widget"), s?.(), e;
			}
		}
	};
}
//#endregion
//#region src/lib/payments/paymentPlace.ts
function Un(e) {
	return "places" in e;
}
var Wn = ({ getOffersClient: e, getPwTools: t, getPaymentAnalytics: n, getWidgetTargetNode: r, modalController: i, logger: a }) => (o) => {
	let s = n(), c = "page" in o ? o.page : "", l = (e) => ({
		eventSessionId: e.eventSessionId,
		positionId: e.analyticData.positionId,
		position: Number(e.analyticData.positionId),
		batchId: e.analyticData.batchId,
		place: e.place ?? "",
		url: window.location.href,
		page: c
	});
	return {
		analytics: {
			async offerShowed(e) {
				s.sendOfferShow(l(e));
			},
			async offerClicked(e) {
				s.sendOfferClick(l(e));
			}
		},
		async getOffers() {
			let t = await e().getOffers(o);
			return t.length && s.sendOffersLoadResult(t), t;
		},
		async getCarouselOffers() {
			let t = e();
			if (!Un(o)) return a.error("Current payment place params are not valid for carousel request"), {};
			let n = await t.getOffersCarousel(o);
			return Object.keys(n).forEach((e) => {
				let t = n?.[e];
				t && s.sendOffersLoadResult(t);
			}), n;
		},
		async checkout(e, n, o) {
			let s = r();
			if (!s) {
				a.error("No target node for payment widget found");
				return;
			}
			let c = Hn(t(), a, {
				eventSessionId: e.eventSessionId,
				batchId: e.analyticData.batchId,
				positionId: e.analyticData.positionId
			}), l = Ln();
			if (l.add(() => c.destroy()), l.add(i.scenario.listen(() => {
				i.scenario.get() === null && l.dispose();
			})), o) {
				let e = () => l.dispose();
				o.addEventListener("abort", e), l.add(() => o.removeEventListener("abort", e));
			}
			let u = (e) => {
				l.dispose(), i.close(), e?.();
			}, d = {
				...n,
				onClose: () => u(n.onClose),
				onNeedAuth: () => u(n.onNeedAuth),
				onScenarioChange: (e) => {
					l.disposed || (i.open(e), n.onScenarioChange?.(e));
				}
			};
			try {
				await c.mount(e, s, d);
			} catch (e) {
				throw l.dispose(), e;
			}
		}
	};
};
//#endregion
//#region src/lib/payments/analytics.ts
function Gn(e) {
	return {
		content_group_uuid: e.contentId,
		promotion_id: e.promotionId
	};
}
var Kn = (e, t) => {
	let { featureFlags: n, channel: r, counterId: i, service: a, logger: o } = t, s = e().plusPaymentEvents;
	return {
		sendOfferClick: async (e) => {
			try {
				e.customParams && s.updateCustomParameters(Gn(e.customParams)), s.offerClick({
					session_id: e.eventSessionId,
					offers_position_id: e.positionId,
					offers_batch_id: e.batchId,
					page: e.page,
					place: e.place,
					from: "",
					position: e.position,
					url: e.url
				});
			} catch (e) {
				o.error({ error: e }, "sendOfferClick error");
			}
		},
		sendOfferShow: async (e) => {
			try {
				e.customParams && s.updateCustomParameters(Gn(e.customParams)), s.offerShow({
					session_id: e.eventSessionId,
					offers_position_id: e.positionId,
					offers_batch_id: e.batchId,
					position: e.position,
					page: e.page,
					place: e.place,
					from: "",
					url: e.url
				});
			} catch (e) {
				o.error({ error: e }, "sendOfferShow error");
			}
		},
		sendOffersLoadResult: async (e) => {
			try {
				if (!e[0]) return;
				let t = J(n.testIds).join(","), { eventSessionId: o } = e[0];
				s.frontSessionStart({
					service: a,
					service_channel: r,
					session_id: o,
					external_test_ids: t,
					external_triggered_test_ids: t
				}, String(i)), e.forEach((e) => {
					s.loadOffersResulted({
						session_id: o,
						target: e.target,
						resulted_offer_position_ids: [e.analyticData.positionId],
						offers_batch_id: e.analyticData.batchId
					});
				});
			} catch (e) {
				o.error({ error: e }, "sendOffersLoadResult error");
			}
		}
	};
};
//#endregion
//#region src/lib/payments/modal.ts
function qn() {
	let e = S(null);
	return {
		open: (t) => {
			e.set(t);
		},
		close: () => {
			e.set(null);
		},
		scenario: e.seal()
	};
}
//#endregion
//#region src/lib/payments/index.ts
var X = x("payments"), Jn = "default", Yn = {
	web: {
		mode: "iframe",
		platform: "web",
		acqPlatform: "Web"
	},
	touch: {
		mode: "iframe",
		platform: "web",
		acqPlatform: "WebTouch"
	},
	desktop: {
		mode: "iframe",
		platform: "web",
		acqPlatform: "WebDesktop"
	}
}, Xn = (e) => {
	let { sessionParams: t, serviceParams: n, lang: r, puid: i } = e, a = Yn[n.platform], o = {
		mode: a.mode,
		platform: a.platform,
		preloadManager: !1,
		lang: r,
		brand: n.brand,
		puid: i ? String(i) : null,
		widgetServiceName: n.widgetServiceName,
		theme: n.theme,
		environment: t.environment,
		serviceSessionId: t.serviceSessionId,
		authMethod: t.authMethod ?? Jn
	};
	return le.from(o);
};
function Zn(e) {
	let { logger: t, featureFlags: n, lang: r, authManager: i, serviceParams: a, sessionParams: o, requester: s, getWidgetTargetNode: c } = e, l = q(() => Xn({
		serviceParams: a,
		sessionParams: o,
		lang: r,
		puid: i.userProfile?.puid
	})), u = q(() => new ce({
		lang: r,
		puid: i.userProfile?.puid ? String(i.userProfile.puid) : null,
		brand: a.brand,
		requester: s,
		platform: Yn[a.platform].acqPlatform,
		authMethod: o.authMethod ?? Jn,
		service: a.widgetServiceName,
		environment: o.environment,
		oAuthToken: null
	})), d = q(() => In(u, {
		logger: t,
		featureFlags: n
	})), f = q(() => Kn(l, {
		featureFlags: n,
		channel: a.channel,
		counterId: a.counterId,
		service: a.name,
		logger: e.logger
	})), p = qn();
	return {
		modal: p,
		createPaymentPlace: Wn({
			getOffersClient: d,
			getPwTools: l,
			getPaymentAnalytics: f,
			getWidgetTargetNode: c,
			modalController: p,
			logger: t
		}),
		ref: () => X
	};
}
//#endregion
//#region src/lib/payments/urlOfferParams.ts
var Z = {
	autoOpen: "isOpenPw",
	target: "target",
	billingFeatureName: "billingFeatureName"
}, Q = {
	autoOpen: "subscription_auto_open",
	target: "subscription_target",
	billingFeatureName: "subscription_billing_feature"
}, Qn = [...Object.values(Z), ...Object.values(Q)], $n = (e) => {
	try {
		let t = new URLSearchParams(e || "");
		if ((t.get(Z.autoOpen) || t.get(Q.autoOpen)) !== "1") return null;
		let n = t.get(Z.target) || t.get(Q.target), r = t.get(Z.billingFeatureName) || t.get(Q.billingFeatureName);
		return !n || !r ? null : {
			target: n,
			billingFeatureName: r
		};
	} catch {
		return null;
	}
}, er = (e, t = window.location.href) => {
	let n = new URL(t);
	return n.searchParams.set(Z.autoOpen, "1"), n.searchParams.set(Z.target, e.target), n.searchParams.set(Z.billingFeatureName, e.billingFeatureName), n;
}, tr = (e, { defaultTarget: t } = {}) => {
	if (!e) return;
	let n = e.requestedFeatures?.[0], r = e.target || t;
	if (!(!n || !r)) try {
		return er({
			target: r,
			billingFeatureName: n
		});
	} catch {
		return;
	}
}, nr = (e) => ee({
	key: (t) => [e, JSON.stringify(t.variables)].join(":"),
	fetch: (e) => e.fetch()
});
function rr(e, t, n) {
	let r = y(X), i = f(() => r.createPaymentPlace(e)), [a] = m(t({
		variables: e,
		fetch: n(i)
	}));
	return {
		offers: a,
		analytics: i.analytics,
		checkout: i.checkout
	};
}
//#endregion
//#region src/hooks/usePaymentPlace.ts
var ir = nr("paymentPlace");
function ar(e, t) {
	return e.find((e) => Object.entries(t).every(([t, n]) => e[t] === n)) ?? null;
}
function or(e) {
	let { offers: t, checkout: n, analytics: r } = rr(e, ir, (e) => e.getOffers);
	return l(() => ({
		offers: t,
		checkout: n,
		analytics: r,
		selectOfferBy: (e) => t?.length ? ar(t, e) : null
	}), [
		t,
		r,
		n
	]);
}
//#endregion
//#region src/hooks/useCarouselPaymentPlace.ts
var sr = nr("carousel");
function cr(e) {
	let { offers: t, checkout: n, analytics: r } = rr(e, sr, (e) => e.getCarouselOffers);
	return l(() => ({
		offers: t,
		checkout: n,
		analytics: r,
		selectOffersByPlace: (e) => t?.[e] ?? null
	}), [
		t,
		r,
		n
	]);
}
//#endregion
//#region src/lib/payments/paymentWidgetParamsManager.ts
function lr(e) {
	return {
		get(t) {
			return e.find((e) => e.read(t) !== null)?.read(t) ?? null;
		},
		set(t) {
			e.forEach((e) => e.write(t));
		},
		clear(t) {
			e.forEach((e) => e.clear(t));
		},
		hasAutoOpenFlag(t) {
			return e.some((e) => e.hasAutoOpenFlag(t));
		}
	};
}
function ur(e) {
	return {
		read(e) {
			return $n(e.search);
		},
		write() {},
		clear(t) {
			try {
				let n = new URLSearchParams(t.search || "");
				Qn.forEach((e) => n.delete(e));
				let r = n.toString();
				if (r !== t.search) {
					let t = r ? new URLSearchParams(r) : void 0;
					e.navigate({
						to: e.location,
						replace: !0,
						meta: t ? { searchParams: t } : void 0
					});
				}
			} catch {}
		},
		hasAutoOpenFlag(e) {
			try {
				return new URLSearchParams(e.search || "").get(Z.autoOpen) === "1";
			} catch {
				return !1;
			}
		}
	};
}
var dr = "openedOfferParams";
function fr(e) {
	let t = () => {
		e.session.remove(dr);
	}, n = (n) => {
		try {
			let n = e.session.get(dr);
			if (!n) return null;
			let r = JSON.parse(n);
			return !r || typeof r != "object" || typeof r.target != "string" || typeof r.billingFeatureName != "string" || !r.target.trim() || !r.billingFeatureName.trim() ? (t(), null) : r;
		} catch {
			return t(), null;
		}
	};
	return {
		read: n,
		write(t) {
			try {
				let n = {
					target: String(t.target).trim(),
					billingFeatureName: String(t.billingFeatureName).trim()
				};
				e.session.set(dr, JSON.stringify(n));
			} catch {}
		},
		clear: (e) => t(),
		hasAutoOpenFlag(e) {
			return n(e) !== null;
		}
	};
}
//#endregion
//#region src/hooks/useAutoOpenPaymentWidget.ts
var pr = ({ isAuthorized: e, hasSpecificSubscription: t, isUrlSourceEnabled: n }) => {
	let r = h(), i = g(), o = de(), s = f(() => {
		let e = fr(o);
		return lr(n ? [ur(r), e] : [e]);
	}), u = l(() => s.get({ search: i?.toString() || "" }), [s, i]), d = !!(u?.billingFeatureName && !t(u.billingFeatureName)), p = d && e, m = a(() => {
		s.clear({ search: i?.toString() || "" });
	}, [s, i]), _ = a((e) => {
		s.set(e);
	}, [s]);
	return c(() => {
		s.hasAutoOpenFlag({ search: i?.toString() || "" }) && (d || s.clear({ search: i?.toString() || "" }));
	}, [
		s,
		d,
		i
	]), {
		shouldOpenWidget: p,
		target: u?.target,
		billingFeatureName: u?.billingFeatureName,
		setParams: _,
		clearParams: m
	};
}, mr = "default";
function hr({ brand: e, environment: t, requester: n }) {
	let r = q(() => new fe({
		brand: e,
		environment: t,
		authMethod: mr,
		getAuthToken: () => null,
		requester: n
	}));
	return async (e) => String(await r().assign(e ?? {})) === "SUCCESS";
}
//#endregion
//#region src/lib/dcb/createDcbManager.ts
var gr = x("dcbManager"), _r = 500, vr = 10;
function yr({ brand: e, environment: t, requester: n, getIsAuthorized: r, getHasSubscription: i, logger: a }) {
	let o = hr({
		brand: e,
		environment: t,
		requester: n
	}), s = S("idle"), c = s.seal(), l = !1;
	async function u() {
		if (l || typeof window > "u" || (l = !0, !r() || i())) return;
		s.set("pending");
		let e = setTimeout(() => {
			s.get() === "pending" && s.set("screen");
		}, _r);
		try {
			if (await o({ maxAttempts: vr })) {
				window.location.reload();
				return;
			}
		} catch (e) {
			a.warn({ error: e }, "DCB autolink assign failed");
		} finally {
			clearTimeout(e);
		}
		s.set("done");
	}
	return {
		phase: c,
		run: u,
		ref: () => gr
	};
}
//#endregion
//#region src/hooks/useDcbAutolink.ts
function br() {
	let e = p(gr), [t, n] = d(e?.phase.get() ?? "idle");
	return o(() => {
		if (!e) return;
		let t = e.phase.listen(() => i(() => {
			n(e.phase.get() ?? "idle");
		}));
		return e.run(), t;
	}, [e]), t === "screen";
}
//#endregion
//#region src/lib/vitals/metric.duration.ts
function xr(e, t) {
	let n = /* @__PURE__ */ new Set(), r = (t) => {
		n.forEach((n) => n(e, t));
	}, i = () => {
		let e = null;
		return {
			begin() {
				e = performance.now();
			},
			end() {
				e !== null && (r(performance.now() - e), e = null);
			},
			cancel() {
				e = null;
			}
		};
	}, a;
	return {
		observe(e) {
			return n.add(e), () => n.delete(e);
		},
		measure() {
			return t?.persistent ? (a ??= i(), a) : i();
		}
	};
}
//#endregion
//#region src/lib/vitals/metric.web-vitals.ts
function Sr(e) {
	let t = /* @__PURE__ */ new Set(), n = (e, n) => {
		t.forEach((t) => t(e, n));
	}, r = /* @__PURE__ */ new Map(), i = () => {
		if (!window || !PerformanceObserver) return;
		let { fcp: t, cls: i, lcp: a, inp: o } = e;
		t && r.set("fcp", Cr((e) => n(t, e))), i && console.warn("Not implemented web vitals metric CLS"), a && console.warn("Not implemented web vitals metric LCP"), o && console.warn("Not implemented web vitals metric INP");
	}, a = () => {
		r.forEach((e) => e.disconnect()), r.clear();
	};
	return {
		observe(e) {
			return t.size === 0 && i(), t.add(e), () => {
				t.delete(e), t.size === 0 && a();
			};
		},
		measure() {}
	};
}
function Cr(e) {
	let t = new PerformanceObserver((n) => {
		let r = n.getEntriesByName("first-contentful-paint")[0];
		r && (t.disconnect(), e(r.startTime));
	});
	return t.observe({
		type: "paint",
		buffered: !0
	}), t;
}
//#endregion
//#region src/lib/vitals/metric.rival-route.ts
function wr(e) {
	let t = /* @__PURE__ */ new Set(), n = (e, n, r) => {
		t.forEach((t) => t(e, n, r));
	};
	return {
		observe(e) {
			return t.add(e), () => t.delete(e);
		},
		measure(t) {
			let r = t.routingStart, i, a = (e) => {
				n(e, performance.now() - r, i);
			}, o = {}, { render: s, fetch: c, complete: l } = e;
			return (s || c || l) && (o.onChange = (e, t) => {
				r = performance.now(), i = {
					from: e,
					to: t
				};
			}), s && (o.onRender = () => a(s)), c && (o.onFetch = () => a(c)), l && (o.onComplete = () => a(l)), o;
		}
	};
}
//#endregion
//#region src/lib/vitals/manager.ts
var Tr = x("vitalsManager");
function Er(e) {
	let { globals: t = [], onReport: n } = e, r = /* @__PURE__ */ new Map(), i = {
		attach(e) {
			r.has(e) || r.set(e, e.observe(n));
		},
		detach(e) {
			r.get(e)?.(), r.delete(e);
		},
		ref: () => Tr
	};
	return t.forEach((e) => i.attach(e)), i;
}
//#endregion
//#region src/hooks/useVitalMetric.ts
function Dr(e, ...[t]) {
	let n = p(Tr), r = e.measure;
	return c(() => (n?.attach(e), () => n?.detach(e)), [n, e]), l(() => r(t), [r]);
}
//#endregion
//#region src/lib/authManager.ts
var Or = x("authManager");
function kr(e) {
	let t = !1, n = "";
	return {
		get isAuthorized() {
			return t;
		},
		get yandexuid() {
			return n;
		},
		setIsAuthorized(e) {
			t = e;
		},
		setYandexuid(e) {
			n = e;
		},
		getLoginUrl(t) {
			let n = new URL("/auth", e.passportHost);
			return n.searchParams.set("origin", e.origin), n.searchParams.set("lang", e.lang), n.searchParams.set("retpath", t.toString()), n;
		},
		getLogoutUrl(t) {
			let r = new URL("/passport", e.passportHost);
			return r.searchParams.set("mode", "logout"), r.searchParams.set("yu", n), r.searchParams.set("retpath", t.toString()), r;
		},
		getAuthAccountUrl(t, r) {
			let i = new URL("/auth", e.passportHost);
			return i.searchParams.set("login", t), i.searchParams.set("yu", n), i.searchParams.set("origin", e.origin), i.searchParams.set("lang", e.lang), i.searchParams.set("retpath", r.toString()), i;
		},
		getChangeMultiAccountUrl(t, r) {
			let i = new URL("/passport", e.passportHost);
			return i.searchParams.set("action", "change_default"), i.searchParams.set("mode", "embeddedauth"), i.searchParams.set("uid", t), i.searchParams.set("yu", n), i.searchParams.set("origin", e.origin), i.searchParams.set("lang", e.lang), i.searchParams.set("retpath", r.toString()), i;
		},
		getAddAccountUrl(t) {
			let n = new URL("/auth", e.passportHost);
			return n.searchParams.set("mode", "add-user"), n.searchParams.set("origin", e.origin), n.searchParams.set("lang", e.lang), n.searchParams.set("retpath", t.toString()), n;
		},
		ref() {
			return Or;
		},
		hydrate(e) {
			t = e.isAuthorized, n = e.yandexuid;
		},
		toJSON() {
			return {
				isAuthorized: t,
				yandexuid: n
			};
		}
	};
}
function $(e, t) {
	let n = new URL("/push", e);
	return n.searchParams.set("retpath", t.toString()), n.searchParams.set("uuid", jr()), n;
}
function Ar({ ssoHost: e, ...t }) {
	let n = kr(t);
	return {
		get isAuthorized() {
			return n.isAuthorized;
		},
		get yandexuid() {
			return n.yandexuid;
		},
		setIsAuthorized: n.setIsAuthorized,
		setYandexuid: n.setYandexuid,
		getLoginUrl(t) {
			return n.getLoginUrl($(e, t));
		},
		getLogoutUrl(t) {
			return n.getLogoutUrl($(e, t));
		},
		getAuthAccountUrl(t, r) {
			return n.getAuthAccountUrl(t, $(e, r));
		},
		getChangeMultiAccountUrl(t, r) {
			return n.getChangeMultiAccountUrl(t, $(e, r));
		},
		getAddAccountUrl(t) {
			return n.getAddAccountUrl($(e, t));
		},
		ref: n.ref,
		hydrate: n.hydrate,
		toJSON: n.toJSON
	};
}
function jr() {
	return typeof crypto < "u" && "randomUUID" in crypto ? crypto.randomUUID() : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (e) => {
		let t = Math.random() * 16 | 0;
		return (e === "x" ? t : t & 3 | 8).toString(16);
	});
}
//#endregion
//#region src/hooks/useAuthManager.ts
function Mr() {
	return y(Or);
}
var Nr = { digit: "Timer_digit__YdBHH" }, Pr = 1e3, Fr = (e) => String(e).padStart(2, "0");
function Ir(e) {
	let t = Math.max(0, e);
	return {
		hours: Fr(Math.floor(t / 36e5)),
		minutes: Fr(Math.floor(t % 36e5 / 6e4)),
		seconds: Fr(Math.floor(t % 6e4 / 1e3))
	};
}
function Lr(e) {
	let { hours: t, minutes: n, seconds: r } = Ir(e);
	return `${t}:${n}:${r}`;
}
var Rr = ({ durationMs: e, onExpire: t, onTick: n, className: r }) => {
	let i = u(null), s = u(null), c = u(null), l = u(t);
	l.current = t;
	let d = u(n);
	d.current = n;
	let f = a((e) => {
		let { hours: t, minutes: n, seconds: r } = Ir(e);
		i.current && i.current.textContent !== t && (i.current.textContent = t), s.current && s.current.textContent !== n && (s.current.textContent = n), c.current && c.current.textContent !== r && (c.current.textContent = r);
	}, []);
	o(() => {
		let t = Date.now(), n = setInterval(() => {
			let r = e - (Date.now() - t);
			r <= 0 ? (clearInterval(n), f(0), d.current?.(0), l.current?.()) : (f(r), d.current?.(r));
		}, Pr);
		return () => clearInterval(n);
	}, [e, f]);
	let p = Ir(e);
	return /* @__PURE__ */ T("div", {
		className: r,
		dir: "ltr",
		children: [
			/* @__PURE__ */ w("span", {
				ref: i,
				className: Nr.digit,
				children: p.hours
			}),
			/* @__PURE__ */ w("span", { children: ":" }),
			/* @__PURE__ */ w("span", {
				ref: s,
				className: Nr.digit,
				children: p.minutes
			}),
			/* @__PURE__ */ w("span", { children: ":" }),
			/* @__PURE__ */ w("span", {
				ref: c,
				className: Nr.digit,
				children: p.seconds
			})
		]
	});
}, zr = "counterOfferLastShownTimestamp", Br = 2e4, Vr = 1440 * 60 * 1e3;
function Hr({ storage: e, hasSubscription: t, hasActiveModal: n, hasCounterOffer: r, isShowForced: i, activityEvents: a, subscribeActivity: s, delayMs: c = Br }) {
	let u = l(() => {
		let t = S(!1), n = null, r = !0;
		return {
			visible: t.seal(),
			setBlocked(e) {
				r = e;
			},
			isCooldownActive() {
				let t = e.local.get(zr) ?? "0";
				return Date.now() - parseInt(t, 10) < Vr;
			},
			show() {
				r || this.isCooldownActive() || (t.set(!0), e.local.set(zr, String(Date.now())));
			},
			hide() {
				t.set(!1);
			},
			startTimer(e) {
				this.clearTimer(), n = setTimeout(() => {
					this.show();
				}, e);
			},
			clearTimer() {
				n &&= (clearTimeout(n), null);
			}
		};
	}, [e]);
	u.setBlocked(t || n || !r);
	let d = _(u.visible);
	return o(() => {
		t && (u.hide(), u.clearTimer());
	}, [t, u]), o(() => {
		i && u.show();
	}, [i, u]), o(() => {
		if (i || t || d || u.isCooldownActive()) return;
		u.startTimer(c);
		let e = () => u.startTimer(c);
		if (s) {
			let t = s(e);
			return () => {
				u.clearTimer(), t();
			};
		}
		return a.forEach((t) => document.addEventListener(t, e)), () => {
			u.clearTimer(), a.forEach((t) => document.removeEventListener(t, e));
		};
	}, [
		i,
		t,
		d,
		u,
		a,
		s,
		c
	]), {
		isVisible: d,
		hide: u.hide
	};
}
//#endregion
export { Le as AnalyticsSenderProvider, De as EvgenLoggerDecorator, At as FooterComponent, Ot as PhoneInput, It as Picture, at as Seo, Rr as Timer, vt as Tooltip, Ce as TrackingProvider, ln as addScript, H as appendScript, kr as createAuthManager, yr as createDcbManager, Pe as createEvgen, Kt as createFeatureFlags, sn as createFlagsScheme, Ue as createFromBlock, mn as createGtmService, Ar as createMDAuthManager, Cn as createMetrikaService, Zn as createPayments, Ut as createPictureFactory, kn as createQueryParamsStore, jt as createRemoteConfig, Ft as createRequestIdManager, wr as createRivalRouteMetric, st as createUseI18n, xr as createVitalDurationMetric, Er as createVitalsManager, Sr as createWebVitalsMetric, gr as dcbManagerRef, Oe as evgenRef, Gt as featureFlagsRef, J as formatTestIds, Lr as formatTimerValue, tr as getAutoOpenWidgetUrlFromOffer, $ as getPushUrl, Yt as getUrlFeatureFlags, q as lazyFactory, $n as parseAutoOpenWidgetParams, X as paymentsRef, R as remoteConfigRef, Pt as requestIdManagerRef, on as schema, ot as seoDictionary, Re as useAnalytics, Mr as useAuthManager, pr as useAutoOpenPaymentWidget, cr as useCarouselPaymentPlace, Hr as useCounterOfferController, br as useDcbAutolink, Fe as useEvgen, qt as useFeatureFlags, We as useFromBlock, hn as useGtmService, ct as useI18n, wn as useMetrikaService, ut as useOuterClick, or as usePaymentPlace, An as useQueryParamsStore, k as useRelativeUrl, Mt as useRemoteConfig, O as useSeoDefaults, Ge as useUpdateLocalSessionId, Dr as useVitalMetric, Tr as vitalsManagerRef };
